import { AppErrorBoundary } from './components/ui/AppErrorBoundary';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './auth/AuthContext';
import { router } from './app/router';
import { isDemo } from './demo/flag';
import { initI18n } from './i18n';
import './theme/global.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Feature queries select an explicit policy; defaults remain conservative.
      staleTime: 0,
      refetchInterval: false,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

async function mount() {
  // Demo mode: the fixture world answers every API call (see src/demo).
  // VITE_DEMO is inlined at build time, so in a production build this branch
  // is dead code and the demo chunk is not emitted at all.
  const demo = import.meta.env.VITE_DEMO === '1' && isDemo() ? await import('./demo/mountDemo') : null;
  const world = demo ? await demo.startDemo() : null;
  // English is loaded before the first paint, so keys never flash on screen.
  await initI18n();

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <AppErrorBoundary><AuthProvider>
          <RouterProvider router={router} />
          {demo && world && <demo.DemoPanel world={world} />}
        </AuthProvider></AppErrorBoundary>
      </QueryClientProvider>
    </React.StrictMode>,
  );
}

void mount();
